import LsdApiModel from './global/LsdApiModel';

export default class ProjectStatsModel extends LsdApiModel {
	static get path(): string {
		return '/projects/stats?projectSubCategory={?projectSubCategory}&expenseGroup={?expenseGroup}';
	}
}
